import React from 'react'
import { Col } from 'reactstrap'
import PropTypes from 'prop-types'
import EmailRouter from '../../Email/EmailRouter'
import EmailLinkFull from './EmailLinkFull'
import EmailLinkSummary from './EmailLinkSummary'

class EmailLink extends EmailRouter {
  constructor (props) {
    super(props)
    this.state = {
      inbox: {}
    }
  }

  componentDidMount () {
    this.props.container.subscribe(this)
  }

  render () {
    const {
      props: {
        forceShowEmailLink,
        shouldShowEmailLink,
        widget
      },
      state: {
        inbox
      }
    } = this

    if (!shouldShowEmailLink && !forceShowEmailLink) {
      return null
    }

    return (
      <Col id={widget.name}>
        {
          this.isResponseFull(inbox) ? (
            <EmailLinkFull widget={widget} box={inbox}/>
          ) : (
            <EmailLinkSummary widget={widget} box={inbox}/>
          )
        }
      </Col>
    )
  }
}

EmailLink.propTypes = {
  widget: PropTypes.object.isRequired,
  shouldShowEmailLink: PropTypes.bool,
  forceShowEmailLink: PropTypes.bool,
  container: PropTypes.object.isRequired
}

EmailLink.defaultProps = {
  shouldShowEmailLink: false,
  forceShowEmailLink: false
}

export default EmailLink
